import ReactImageGallery, { ReactImageGalleryItem } from "react-image-gallery";
import { useRef } from "react";
import "react-image-gallery/styles/css/image-gallery.css";
import "./styles.scss";

export type IImage = {
  src: string;
  alt?: string;
};

type ImageGalleryProps = {
  images: IImage[];
  className?: string;
  isModal?: boolean;
};

const ImageGallery = ({ images }: ImageGalleryProps) => {
  const reactImageGalleryRef = useRef<ReactImageGallery>(null);

  let items: ReactImageGalleryItem[] = images.map((image) => ({
    original: image.src,
    originalAlt: image.alt,
    originalClass: "image-gallery-image-height",
  }));

  const disableAutoPlay = () => {
    reactImageGalleryRef.current?.pause();
  };

  return (
    <ReactImageGallery
      items={items}
      autoPlay
      onTouchStart={disableAutoPlay}
      showPlayButton={false}
      showFullscreenButton={window.innerWidth > 700}
      renderRightNav={(onClick, disabled) => {
        return (
          <button
            type="button"
            className="image-gallery-icon image-gallery-right-nav"
            disabled={disabled}
            onClick={(e) => {
              disableAutoPlay();
              onClick(e);
            }}
            aria-label="Next Slide"
          >
            <svg
              className="image-gallery-svg"
              fill="none"
              stroke="currentColor"
              strokeWidth={1}
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="6 0 12 24"
            >
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        );
      }}
      renderLeftNav={(onClick, disabled) => {
        return (
          <button
            type="button"
            className="image-gallery-icon image-gallery-left-nav"
            disabled={disabled}
            onClick={(e) => {
              disableAutoPlay();
              onClick(e);
            }}
            aria-label="Prev Slide"
          >
            <svg
              className="image-gallery-svg"
              fill="none"
              stroke="currentColor"
              strokeWidth={1}
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="6 0 12 24"
            >
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
        );
      }}
      showIndex
      ref={reactImageGalleryRef}
      stopPropagation={false}
    />
  );
};

export default ImageGallery;
